import * as React from "react";
import * as ManageDashboardDialog from "Dashboards/Components/Shared/ManageDashboardDialog/ManageDashboardDialog";
import { IManageDashboardDialogProps } from "Dashboards/Components/Shared/ManageDashboardDialog/ManageDashboardDialog";
import { registerLWPComponent } from "VSS/LWP";
import { Dashboard } from "TFS/Dashboards/Contracts";

/**
 * NOTE: This interface is duplicated in
 * Tfs\Web\extensions\dashboards\dashboard-view\scripts\redux\Saga.ts
 * Any changes here must be updated there as well.
 */
interface ManageDashboardDialogShimProps {
    dashboard: Dashboard;
    team: { id: string, name: string };
    onSave: (updatedDashboard: Dashboard) => void;
    onDismiss: () => void;
}

/**
 * Allows rendering the old web platform "manage dashboard" dialog in the new web platform.
 */
class ManageDashboardDialogShim extends React.Component<ManageDashboardDialogShimProps> {
    public static readonly componentType = "ManageDashboardDialog";

    public componentDidMount() {
        ManageDashboardDialog.show(this.shimPropsToDialogProps());
    }

    public render(): null {
        return null;
    }

    private shimPropsToDialogProps(): IManageDashboardDialogProps {
        const {
            dashboard,
            team: { id: teamId, name: teamName },
            onSave,
            onDismiss
        } = this.props;

        return {
            dashboard,
            team: { teamId, teamName },
            onSave,
            onDismiss
        };
    }
}

registerLWPComponent(ManageDashboardDialogShim.componentType, ManageDashboardDialogShim);